import { render } from "./index.vue?vue&type=template&id=d5fe590c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d5fe590c&lang=scss&scoped=true"

import exportComponent from "D:\\code\\csgj\\sjg-wine-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5fe590c"]])

export default __exports__